import { History } from 'history';
import { useContext, useEffect } from 'react';
import { Navigator } from 'react-router';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'; // v6.4 is breaking change

type ExtendNavigator = Navigator & Pick<History, 'block'>;

/*
  This likely needs to be refactored slightly to accommodate for _allowing_ certain transitions to go through, but block others.
  I've attempted to do so with the `shouldIgnore` you see on L40, but the overloaded tx.retry() _unblocks_ the navigation block, _then_ calls retry().
  This means it will indeed let the transition go through, but seeing it's now unblocked, will allow any subsequent ones to go through too.

  Best I can think of is if we find a means of calling retry() on L48 and then _reblocking_ the navigation block, but I'm not sure how we do that.

  Other alternative is, on L176 of App.tsx, not have the second route match, and show the SingleMenu component declaratively if the pathname includes the item ID.
  This means no route change takes place, thus we sidestep this entire thing.
  We'd then just need to hook into useLocation with a useEffect to see if the pathname includes the item ID, and if so, show the modal.
*/

export function useBlocker(message: string, callback?: () => void, when = true): void {
  const { navigator } = useContext(NavigationContext);
  useEffect((): (() => void) | undefined => {
    if (!when) return undefined;

    const unblock = (navigator as ExtendNavigator).block((tx) => {
      const {
        location: { pathname }
      } = tx;

      const shouldIgnore = pathname.includes('/menus/');
      if (shouldIgnore) {
        unblock();
        tx.retry();
      } else if (window.confirm(message)) {
        if (callback) {
          callback();
        }
        unblock();
        tx.retry();
      }
    });

    return unblock;
  });
}

export function usePrompt(message: string, callback?: () => void, when = true): void {
  useBlocker(message, callback, when);
}
